import SettingRepository from "../../api/repositories/settingRepository";
import LicenseRepository from "../../api/repositories/licenseRepository";

export const configuration = {
  namespaced: true,
  state: {
    darkmode: false,
    SO_API_BASE_URL: null,
    userSettings: {},
    license: {},
  },

  actions: {
    setDarkmode({ commit }, message) {
      if (typeof message == "boolean") {
        commit("SET_DARKMODE", message);
      }
    },

    async getBaseUrl({ commit }) {
      if (this.state.SO_API_BASE_URL == undefined) {
        if (process.env.NODE_ENV == "development")
          commit("SET_BASE_URL", "http://localhost:5000");
        else {
          try {
            const envConfig = await fetch("/environmentConfig.json");
            var envJson = await envConfig.json();
            commit("SET_BASE_URL", envJson.SO_API_BASE_URL);
          } catch (exception) {
            commit("SET_BASE_URL", process.env.VUE_APP_SO_API_BASE_URL);
          }
        }
      }
    },

    async getLicenseTerms({ commit, rootState }) {
      var user = rootState.users.currentUser;

      await LicenseRepository.getTerms(user).then((res) =>
        commit("SET_LICENSE", res.data)
      );
    },

    async getUserSettings({ commit, rootState }) {
      var user = rootState.users.currentUser;
      await SettingRepository.get(user).then((data) =>
        commit("SET_USER_SETTINGS", data.data)
      );
    },

    async setUserSettings({ dispatch, rootState }, payload) {
      var user = rootState.users.currentUser;
      await SettingRepository.set(user, payload).then(() =>
        dispatch("getUserSettings")
      );
    },
  },

  mutations: {
    SET_DARKMODE(state, message) {
      state.darkmode = message;
    },
    SET_BASE_URL(state, url) {
      state.SO_API_BASE_URL = url;
    },

    SET_USER_SETTINGS(state, payload) {
      for (var i in Object.keys(payload)) {
        let key = Object.keys(payload)[i];
        if (payload[key] == "true" || payload[key] == "false")
          payload[key] = payload[key] == "true" ? true : false;
      }

      state.userSettings = payload;
    },

    SET_LICENSE(state, payload) {
      state.license = payload;
    },
  },
};
